<div class="work-ui-lightbox">
  @if (isOpen()) {
    <div [class.fade-out]="closeAnimation"
         class="work-ui-lightbox__backdrop fade-in">
      @if (isLoading) {
        <work-ui-loading-spinner [iconSize]="64"
                                 [pageOverlay]="true"
                                 loadingState="loading"
                                 theme="white" />
      }
      <div class="work-ui-lightbox__toolbar">
        @let buttonIconPadding = 4;

        @if (!readonly()) {
          <work-ui-button (buttonClick)="showMetaInfo = !showMetaInfo"
                          [iconOnly]="true"
                          [iconPadding]="buttonIconPadding"
                          [tooltipDescription]="'BILD_INFORMATIONEN' | translate"
                          class="work-ui-lightbox__toolbar-desktop"
                          iconName="info"
                          variant="tertiary-white" />
          <!-- Mobile: Info bleibt links, gleich gross wie die Knöpfe rechts (42 px). -->
          <work-ui-button (buttonClick)="showMetaInfo = !showMetaInfo"
                          [iconOnly]="true"
                          [iconPadding]="11"
                          class="work-ui-lightbox__toolbar-mobile-start"
                          iconName="info"
                          variant="tertiary-white" />
        } @else {
          <span class="work-ui-lightbox__toolbar-desktop"></span>
        }

        <!-- Desktop: Icon-Leiste mit Tooltips. -->
        <div class="work-buttons work-ui-lightbox__toolbar-desktop">
          @if (annotationCounterpart(); as counterpart) {
            <work-ui-button (buttonClick)="showDocument(counterpart)"
                            [iconOnly]="true"
                            [iconPadding]="buttonIconPadding"
                            [tooltipDescription]="(currentImage().sourceDocumentId ? 'BILD_BESCHRIFTEN_ORIGINAL_ANZEIGEN' : 'BILD_BESCHRIFTEN_FASSUNG_ANZEIGEN') | translate"
                            iconName="compare"
                            variant="tertiary-white" />
          }
          @if (canAnnotate()) {
            <work-ui-button (buttonClick)="startAnnotation()"
                            [iconOnly]="true"
                            [iconPadding]="buttonIconPadding"
                            [tooltipDescription]="'BILD_BESCHRIFTEN' | translate"
                            iconName="draw"
                            variant="tertiary-white" />
          }
          @if (!readonly() && canDelete()) {
            <work-ui-button (actionConfirmResult)="delete()"
                            [iconOnly]="true"
                            [iconPadding]="buttonIconPadding"
                            [tooltipDescription]="'LOESCHEN' | translate"
                            iconName="delete"
                            variant="tertiary-white"
                            workUiShowConfirmActionModal />
          }
          @if (!hideDownload()) {
            <work-ui-button [htmlLink]="downloadDocumentUrl"
                            [iconOnly]="true"
                            [iconPadding]="buttonIconPadding"
                            [tooltipDescription]="'HERUNTERLADEN' | translate"
                            iconName="download"
                            variant="tertiary-white" />
          }
          @if (canRotate()) {
            <work-ui-button (buttonClick)="rotateImage(true)"
                            [iconOnly]="true"
                            [iconPadding]="buttonIconPadding"
                            [tooltipDescription]="'BILD_NACH_LINKS_DREHEN' | translate"
                            iconName="rotate_90_degrees_ccw"
                            variant="tertiary-white" />
            <work-ui-button (buttonClick)="rotateImage()"
                            [iconOnly]="true"
                            [iconPadding]="buttonIconPadding"
                            [tooltipDescription]="'BILD_NACH_RECHTS_DREHEN' | translate"
                            iconName="rotate_90_degrees_cw"
                            variant="tertiary-white" />
          }
        </div>

        <!-- Mobile: Hover-Tooltips gibt es nicht. Hauptaktion mit Text, der Rest im «…»-Menü mit Icon und Beschriftung. -->
        <div class="work-buttons work-ui-lightbox__toolbar-mobile">
          @if (canAnnotate()) {
            <work-ui-button (buttonClick)="startAnnotation()"
                            iconName="draw"
                            text="BILD_BESCHRIFTEN"
                            variant="tertiary-white" />
          }
          @if (mobileMenuOptions().length) {
            <work-ui-dropdown-button (actionSelected)="selectMobileMenuAction($event)"
                                     [dropdownOptions]="mobileMenuOptions()"
                                     [tooltipDescription]="'WEITERE_AKTIONEN' | translate"
                                     buttonSize="default"
                                     buttonVariant="tertiary-white" />
          }
          <!-- Gleich gross wie die Knöpfe daneben (42 px) — auch als Touch-Ziel. -->
          <work-ui-button (buttonClick)="close()"
                          [iconOnly]="true"
                          [iconPadding]="11"
                          iconName="close"
                          variant="tertiary-white" />
        </div>

        <work-ui-button (buttonClick)="close()"
                        [iconOnly]="true"
                        [iconPadding]="buttonIconPadding"
                        [tooltipDescription]="'SCHLIESSEN' | translate"
                        class="work-ui-lightbox__toolbar-desktop"
                        iconName="close"
                        variant="tertiary-white" />
      </div>

      <div class="work-ui-lightbox__content">
        <div [class.open]="showMetaInfo"
             class="work-ui-lightbox__content-meta-info work-text-color-white">
          <div class="work-description-details-list work-description-details-list--responsive">
            <dl>
              <dt><b>{{ 'NAME' | translate }}</b></dt>
              <dd>
                <p>{{ currentImage().name }}</p>
              </dd>

              @if (connectedProjectNameMap()) {
                <dt><b>{{ 'PROJEKT' | translate }}</b></dt>
                <dd>
                  <p>{{ projectName }}</p>
                </dd>
              }

              <dt><b>{{ 'AUFGENOMMEN' | translate }}</b></dt>
              <dd>
                <p>{{ currentImage().created | formatDate: 'dddd, DD.MM.YYYY, HH:mm [Uhr]' }}</p>
              </dd>

              <dt><b>{{ 'HOCHGELADEN' | translate }}</b></dt>
              <dd>
                <p>{{ currentImage().upload | formatDate: 'dddd, DD.MM.YYYY, HH:mm [Uhr]' }}</p>
              </dd>

              @if (user) {
                <dt><b>{{ 'HOCHGELADEN_VON' | translate }}</b></dt>
                <dd>
                  <p>{{ user.firstName }} {{ user.lastName }}</p>
                </dd>
              }
            </dl>
          </div>
        </div>

        <div #imageContainer
             class="work-ui-lightbox__content-image-container">
          @if (!(currentIndex() === 0)) {
            <work-ui-button (buttonClick)="navigatePrevious()"
                            [iconOnly]="true"
                            class="work-ui-lightbox__prev"
                            iconName="arrow_back" />
          }

          <div class="work-ui-lightbox__content-image-wrapper"
               (touchstart)="handleTouchStart($event)"
               (touchend)="handleTouchEnd($event)">
            @if (currentImage().mimetype?.startsWith('video/')) {
              @switch (currentImage().processingStatus) {
                @case (WorkDocumentProcessingStatusEnum.Pending) {
                  <div class="work-text-color-white flex gap-12 flex-column justify-center center">
                    <work-ui-icon [fontSize]="56" name="schedule" />
                    <h3>{{ 'VIDEO_WIRD_VERARBEITET' | translate }}</h3>
                    <p>{{ 'BITTE_WARTEN' | translate }}</p>
                  </div>
                }
                @case (WorkDocumentProcessingStatusEnum.Done) {
                  <video [src]="currentImage().fileSrc | prependServerToFileSrc"
                         autoplay
                         controls data-testid="videoElement"></video>
                }
                @case (WorkDocumentProcessingStatusEnum.Failed) {
                  <div class="work-text-color-white flex gap-12 flex-column justify-center center">
                    <work-ui-icon [fontSize]="56" name="broken_image" />
                    <h3>{{ 'FEHLERHAFTE_DATEI' | translate }}</h3>
                    <p>{{ 'UPLOAD_FEHLER' | translate }}</p>
                  </div>
                }
              }
            } @else {
              <img #image
                   (mousedown)="handleMouseDown($event)"
                   [alt]="currentImage().name"
                   [src]="currentImage().fileSrc | prependServerToFileSrc"
                   [style.transform]="'scale(' + zoomLevel + ') translate(' + translatePosition.x + 'px, ' + translatePosition.y + 'px)'"
                   draggable="false">
            }
          </div>

          @if (!(currentIndex() === images().length - 1)) {
            <work-ui-button (buttonClick)="navigateNext()"
                            [iconOnly]="true"
                            class="work-ui-lightbox__next"
                            iconName="arrow_forward" />
          }
        </div>
      </div>
    </div>

    @if (annotationSession(); as session) {
      <work-ui-image-annotator (cancelled)="annotationSession.set(null)"
                               (saved)="saveAnnotation($event)"
                               [annotationJson]="session.annotationJson"
                               [imageSrc]="session.imageSrc"
                               [saving]="annotationSaving()" />
    }
  }
</div>
